// splitterConfig.js
import VectorLogin from "../assets/images/Vector 5 (1).png";
import VectorSignup from "../assets/images/Vector-signup.png";

export const SPLITTER_CONFIG = {
    login: {
        vector: VectorLogin,
        vectorClass: "vector-login",
        textMargin: "95px 30px",
        bgColor: "#0085FD",
        translationKey: "LogIn.BuySellText"
    },
    signup: {
        vector: VectorSignup,
        vectorClass: "vector-signup",
        textMargin: "95px 30px",
        bgColor: "#0085FD",
        translationKey: "LogIn.BuySellText"
    },
    agentLogin: {
        vector: VectorLogin,
        vectorClass: "vector-login",
        textMargin: "95px 30px",
        bgColor: "#0085FD",
        translationKey: "LogIn.BuySellText"
    },
    agentSignup: {
        vector: VectorSignup,
        vectorClass: "vector-signup",
        textMargin: "95px 30px",
        bgColor: "#0085FD",
        translationKey: "LogIn.BuySellText"
    },
};
